import _ from 'underscore';

export const FEATURE__REFINE = 'feature/refine-endpoint';
export const FEATURE__LOGGING = 'feature/logging';
export const FEATURE__SORT_AUCTIONEERS = 'feature/sort-auctioneer';
export const FEATURE__HIGHLIGHT_PREMIUM = 'feature/highlight-premium';
export const FEATURE__SHOWCASE = 'feature/showcase';
export const FEATURE__BROWSER_ROUTER = 'feature/browser-router';
export const FEATURE__AUCTIONEERS_ONLY = 'feature/auctioneers-only';

const FEATURES = [
    FEATURE__REFINE,
    FEATURE__LOGGING,
    FEATURE__SORT_AUCTIONEERS,
    FEATURE__HIGHLIGHT_PREMIUM,
    FEATURE__SHOWCASE,
    FEATURE__BROWSER_ROUTER,
    FEATURE__AUCTIONEERS_ONLY,
];

const DEFAULT_FEATURE_STATE = false;

let _featureStates = _(FEATURES).reduce(
    (acc, feature) => {
        acc[feature] = DEFAULT_FEATURE_STATE;

        return acc;
    },
    {}
);

export const getFeature = (feature) => {
    let flagState = _featureStates[feature];

    return _(flagState).isUndefined()
        ? DEFAULT_FEATURE_STATE
        : _featureStates[feature];
};

export const setFeature = (feature, state) => {
    if (!_(FEATURES).contains(feature)) {
        throw new Error(`Invalid feature ${feature}`);
    }

    return _featureStates[feature] = !!state;
};
